/* eslint-disable no-useless-escape */
import * as Yup from 'yup';

export default Yup.object().shape({
  notification_email: Yup.mixed().when('isArray', {
    is: Array.isArray,
    then: Yup.array().of(Yup.string()),
    otherwise: Yup.string(),
  }),
});
